<template>
  <v-row justify="center">
    <v-dialog v-model="addDialogVersion" persistent max-width="670px">
      <v-card class="#FFCD" color="#f9f9f9">
        <v-card-title> Add Version </v-card-title>
        <v-form ref="form1" lazy-validation class="mr-6 ml-6 pb-6">
          <v-card class="rounded-larg rounded-lg" elevation="3" tile>
            <v-list-item>
              <v-list-item-content
                class="pl-3 pr-3"
                v-if="uploadedFile == false"
              >
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      :rules="[rules.required]"
                      :search-input.sync="publisherNameSearch"
                      v-model="publisherID"
                      class="mx-3"
                      :items="listPublishers"
                      dense
                      label="Publisher Name"
                      outlined
                      item-text="publishername"
                      item-value="publisherid"
                      @keyup="searchPublishers()"
                      @keyup.ctrl.enter="addDialogPublisher = true"
                    ></v-autocomplete>
                    <v-text-field
                      :rules="[rules.required, rules.onlynumber]"
                      v-model="publisherYear"
                      class="mx-3"
                      label="Published Year"
                      outlined
                      dense
                    ></v-text-field>
                    <v-file-input
                      :rules="[rules.required]"
                      class="mx-3"
                      label="Book File"
                      @change="selectBookFile"
                      outlined
                      dense
                    ></v-file-input>
                    <v-row>
                      <v-col cols="12" lg="6" class="pl-6">
                        <v-switch
                          class="mt-0"
                          v-model="status"
                          label="Status"
                          color="primary"
                          hide-details
                        ></v-switch>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-switch
                          class="mt-0"
                          v-model="defaultbook"
                          label="Default Book"
                          color="primary"
                          hide-details
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-card-actions class="pa-0">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close()"
                    >Close</v-btn
                  >
                  <v-btn
                    data-cy="uploadFileBTN"
                    color="blue darken-1"
                    text
                    @click="uploadFile"
                    :loading="loadinguploadFile"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-list-item-content>

              <v-list-item-content v-else class="pl-3 pr-3">
                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Meta Name</th>
                            <th class="text-left">Meta Value</th>
                            <th class="text-left">Remover</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in metaInfo" :key="index">
                            <td>
                              <v-text-field
                                class="mt-4"
                                label="Meta Value"
                                :rules="[rules.required]"
                                name="login"
                                v-model="item.meta_name"
                                outlined
                                dense
                              >
                              </v-text-field>
                            </td>
                            <td>
                              <v-text-field
                                class="mt-4"
                                label="Meta Value"
                                :rules="[rules.required]"
                                name="login"
                                v-model="item.meta_value"
                                outlined
                                dense
                              >
                              </v-text-field>
                            </td>
                            <td class="pb-4">
                              <span @click="removerMeta(index)"
                                ><i
                                  class="status fa fa-times-circle red--text"
                                ></i
                              ></span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-btn
                      color="primary"
                      class="white--text float-left mt-4"
                      @click="saveVersion"
                    >
                      Save
                    </v-btn>
                    <v-btn
                      color="#1B5E20"
                      class="white--text float-right mt-4"
                      @click="newMeta"
                    >
                      New Meta
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["addDialogVersion", "ItemDetails"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        requiredArray: (value) => value != "" || "Field required.",
        maxvalue: (value) =>
          value.length <= 128 || "Maximum length is 128 characters",
        onlynumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) || "Value Only Number",
      },
      loadinguploadFile: false,
      uploadedFile: false,
      publisherID: "",
      publisherNameSearch: "",
      loadingAdd: false,
      listPublishers: [],
      publisherYear: "",
      fileBook: "",
      status: 1,
      defaultbook: 1,
      metaInfo: [],
      VersionID: "18",
    };
  },
  mounted() {
    this.getAllPublishers();
  },

  methods: {
    uploadFile() {
      if (this.$refs.form1.validate() != false) {
        this.loadinguploadFile = true;
        const fd = new FormData();
        if (this.status == true) {
          this.status = 1;
        } else {
          this.status = 0;
        }
        if (this.defaultbook == true) {
          this.defaultbook = 1;
        } else {
          this.defaultbook = 0;
        }

        fd.append("file", this.fileBook);
        fd.append("status", this.status),
          fd.append("isdefault", this.defaultbook);
        fd.append("publisher[publisherid]", this.publisherID);
        fd.append("publisher[year]", this.publisherYear);

        let DataForm = {
          Param: fd,
          API: "/admin/book/" + this.ItemDetails.bookid + "/version",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then((responce) => {
            this.uploadedFile = true;
            this.VersionID = responce.data.data.versionid;
            this.$store
              .dispatch(
                "GetFromAPI",
                "/admin/book/" +
                  this.ItemDetails.bookid +
                  "/version/" +
                  this.VersionID +
                  "/metainfo/generate"
              )
              .then((responseMeta) => {
                this.loadinguploadFile = false;
                this.metaInfo = responseMeta["data"]["data"];
              });
          })
          .catch((error) => {
            this.loadinguploadFile = false;
            let errorObj = error.data.data;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    saveVersion() {
      if (this.$refs.form1.validate() != false) {
        this.loadingStepThree = true;
        let DataForm = {
          Param: {
            metainfo: this.metaInfo,
          },
          API:
            "/admin/book/" +
            this.ItemDetails.bookid +
            "/version/" +
            this.VersionID +
            "/metainfo",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then(() => {
            this.loadingStepThree = false;
            this.$store.dispatch("PushSuccessMsg", "Success Added Book");
            this.$emit("DialogClose", true);
          })
          .catch((error) => {
            this.loadingStepThree = false;
            let errorObj = error.data.data;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/publisher?per_page=20&filter[publishername]=" +
            this.publisherNameSearch
        )
        .then((response) => {
          this.listPublishers = response["data"]["data"];
        });
    },
    searchPublishers() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllPublishers();
      }
    },
    selectBookFile(file) {
      this.fileBook = file;
    },
    close() {
      this.$emit("DialogClose", false);
    },
    removerMeta(index) {
      this.metaInfo.splice(index, 1);
    },
    newMeta() {
      this.metaInfo.push({ meta_name: "", meta_value: "" });
    },
  },
};
</script>
